/* eslint import/prefer-default-export: 0 */
import { trackEvent } from 'common/analytics';

export const trackClickOpenClientHistory = () => {
  trackEvent('review', 'click', 'client-history');
};
